
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dispensary/[cName]/product/[productId]",
      function () {
        return require("private-next-pages/dispensary/[cName]/product/[productId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dispensary/[cName]/product/[productId]"])
      });
    }
  